const renderTrustedForm = trustedform_cfid => `{{{trustedform}}}`

const renderLeadId = leadid_cfid => `
    <script id="LeadiDscript" type="text/javascript">
    // <!--
    (function() {
    var s = document.createElement('script');
    s.id = 'LeadiDscript_campaign';
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//create.lidstatic.com/campaign/{{@system_config.jornaya.leadid_key}}.js?snippet_version=2';
    var LeadiDscript = document.getElementById('LeadiDscript');
    LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
    })();
    // -->
    </script>
    <noscript><img src='//create.leadid.com/noscript.gif?lac=934e3705-ae01-d5f3-9e2b-b9a54e634c7a&lck={{@system_config.jornaya.leadid_key}}&snippet_version=2' /></noscript>
    `

const renderLeadIdHidden = () => `
        <input id="leadid_token" name="universal_leadid" type="hidden" value=""/>
    `
const renderConsentText = (consentTextActive, consentText, cfid) => {
  if (!consentTextActive) return ''
  return `{{#tcpa_consent_text cfid="${cfid}"}} ${consentText} {{/tcpa_consent_text}}`
}

const renderSkipOption = (skipAnswer, isMultipleAnswers) => (skipAnswer && !isMultipleAnswers) && `<li class="tcpa-item-answer"><button type="button" class="tcpa-answer custom-tcpa-skip" data-id="${skipAnswer.key}" style="background-color:rgba(${skipAnswer.color}); color:rgba(${skipAnswer.fontcolor});">${skipAnswer.answer}</button></li>` || ''

const render = ({ question, answers, cfid, trustedform, trustedform_cfid, leadid, leadid_cfid, isMultipleAnswers, consentTextActive, consentText, consentPosition, manualSubmit = false, required = false, saveConsentText = false, autoScrollToConsent = false, skipAnswer }) => {
  const checkbox = isMultipleAnswers ? `<input type="checkbox" class="tcpa-item-answer-checkbox">` : '';
  const btnContinue = isMultipleAnswers ? `<div class="tcpa-continue-container"><button class="bt-continue tcpa-continue-button" type="button" >Continue</button></div>` : '';
  const answersStr = (answers || []).map(a => `<li class="tcpa-item-answer"><button type="button" class="tcpa-answer ${isMultipleAnswers ? 'multiple' : ''}" data-id="${a.key}" {{#dnd-safe}} style="background-color:rgba(${a.color}); color:rgba(${a.fontcolor});" {{/dnd-safe}} >${checkbox}${a.answer}</button></li>`).join("\n");
  const trustedFormStr = trustedform === true ? renderTrustedForm(trustedform_cfid) : ''
  const leadIdStr = leadid === true ? renderLeadId(leadid_cfid) : ''
  const requiredFeedback = `<span class='invalid-feedback tcpa-required-feedback'>Please, select an option.</span>`
  const consentHTML = renderConsentText(consentTextActive, consentText, cfid)
  const skipOpt = renderSkipOption(skipAnswer, isMultipleAnswers)
  return `
<form class="tcpa-questionary-form" data-tf-element-role="offer">
<input type="hidden" name="tf-phone" value="{phone}"/>
<div class="tcpa-questionary" data-tcpa="question" data-question="${cfid}"
            data-trustedform="${trustedform_cfid || ''}" data-leadid="${leadid_cfid || ''}" data-key="{pe_key}" data-multiple="${isMultipleAnswers}" data-required="${required}" data-manual-submit="${manualSubmit}" data-save-consent-text="${saveConsentText}" data-auto-scroll-to-consent="${autoScrollToConsent}">
<div class="tcpa-question">${question ? question : ''}</div>
${consentPosition === 'before' ? consentHTML : ''}
<ul class="tcpa-answers ${manualSubmit || required ? 'tcpa-required' : ''}">
${answersStr}
${skipOpt}
</ul>
${manualSubmit || required ? requiredFeedback : ''}
${btnContinue}
${consentPosition !== 'before' ? consentHTML : ''}
</div>
${trustedFormStr}
${leadid === true ? renderLeadIdHidden() : ''}
</form>
${leadIdStr}
{{#dnd-safe}}
<style>
    .tcpa-consent-text, .tcpa-consent-text label { font-size: 90%; text-align: center; margin-top: 0.75rem; }
    .tcpa-questionary {width:80%; margin: 0 auto;}
    .tcpa-question {text-align: center; font-weight:bold;font-size:20px;width:100%;}
    .tcpa-answers {list-style-type:none; text-align:center; padding: 0; }
    .tcpa-item-answer {display: block;}
    .tcpa-item-answer button {display: inline-block; }
    .tcpa-item-answer button.multiple {display: inline-flex; }
    .tcpa-answers button, .tcpa-continue-container button { border-radius: 5px; min-width: 200px; height: 40px; border: 0; margin-bottom: 10px; margin-right: 10px !important; font-weight: bold; cursor: pointer;}
    .tcpa-continue-container {text-align:center;}
    .tcpa-continue-container button {background-color:#dadada;}

    .tcpa-required.error ~ .tcpa-required-feedback { display: block; }

    .tcpa-required-feedback {
      display: none;
      text-align: center;
      color: #f03030;
      margin-bottom: 0.75rem;
    }
    .tcpa-required.error ~ .tcpa-required-feedback { display: block; }

    @media (hover:none), (hover:on-demand) {
      button:hover {
        /* suppress hover effect on devices that don't support hover fully */
        background: none;
      }
    }
</style>
{{/dnd-safe}}
    `.trim()
};

export default render;
